// Every translation the backend resolves (getIntl, getLocalizedBackendMessages) comes from this
// dictionary, so Lambda bundles never embed frontend-only namespaces and a wording change in those
// files does not redeploy them. backendMessages.test.ts scans the backend sources to keep it complete.
import { BackendMessagesDE } from './de/backendMessagesDE';
import { BackendMessagesEN } from './en/backendMessagesEN';
import { BackendMessagesFR } from './fr/backendMessagesFR';
import { BackendMessagesNL } from './nl/backendMessagesNL';

export { BackendMessagesDE, BackendMessagesEN, BackendMessagesFR, BackendMessagesNL };

export const allLanguageBackendMessages = {
  DE: BackendMessagesDE,
  FR: BackendMessagesFR,
  NL: BackendMessagesNL,
  EN: BackendMessagesEN,
};
